import styled from 'styled-components';
import gestanteImage from 'assets/LandingPage/10.png';

interface ImageSectionProps {
  imageUrl?: string;
}

export const LandingPageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background-size: contain;

  @media (max-width: 768px) {
    background-size: auto;
  }
`;

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #e8b4d4;
  color: white;
  border-radius: 24px;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 20px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Text = styled.span`
  color: white;
`;

export const Highlight = styled.span`
  color: #ec4899;
`;

export const Title = styled.h2`
  display: flex;
  align-items: center;
  font-size: 2.75rem;
  font-weight: bold;
  color: #807f7e;
  line-height: 1.2;
  gap: 0.5rem;

  @media (max-width: 640px) {
    font-size: 2.5rem;
    display: flex;
    flex-direction: column;
    gap: 0;
  }
`;

export const LandingPageResume = styled.div`
  background-color: #fff6fb;

  min-height: 300px;
  margin-top: 40px;
  padding-top: 78px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    height: auto;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-top: 0;
  }

  h1 {
    font-weight: 800;
    font-size: var(--font-larger);
    text-transform: uppercase;
    color: var(--primary-color);
    @media (max-width: 768px) {
      text-align: center;
    }
  }

  p {
    width: 600px;
    align-items: start;
    margin-top: 12px;
    font-size: var(--font-large);

    @media (max-width: 768px) {
      width: auto;
    }
  }

  .options-info {
    display: flex;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 30px;
    align-items: center;
    height: 280px;
    justify-content: space-evenly;

    @media (max-width: 768px) {
      flex-direction: column;
      height: auto;
      margin-top: 50px;
      gap: 50px;
    }

    div {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 300px;
      height: 230px;

      @media (max-width: 768px) {
        width: auto;
        height: auto;
      }

      img {
        width: 130px;
        height: 130px;
      }

      .woman-baby {
        width: 200px;
        height: 140px;
      }

      span {
        margin-top: 30px;
        color: var(--secondary-color-light);
        font-weight: 800;
        text-align: center;
        text-transform: uppercase;
        line-height: 24px;
        letter-spacing: 2px;
      }
    }
  }
`;

export const LandingPageButtonSubscribe = styled.div`
  background-color: var(--default-background-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 100px;

  button {
    background-color: var(--primary-color);
    min-width: 500px;
    height: 68px;
    font-size: var(--font-larger);

    @media (max-width: 768px) {
      min-width: 10px;
      width: 90%;
      height: 45px;
      font-size: var(--font-large);
    }
  }

  p {
    color: var(--secondary-color);
    text-transform: uppercase;
    font-weight: 800;
    margin-top: 5px;
    font-size: var(--font-small);
  }
`;

export const BannerContainer = styled.div`
  display: flex;
  height: 400px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);

  margin: 80px auto;
  max-width: 1400px;
  width: 100%;

  @media (max-width: 768px) {
    height: auto;
    margin: 20px auto;
  }
`;

export const ImageSection = styled.div`
  flex: 1;
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    url(${gestanteImage});
  background-size: cover;
  background-position: center;

  margin-right: -10px;
  z-index: 99;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ContentSection = styled.div`
  flex: 1;
  background: linear-gradient(90deg, #5e287e 1%, #d82e88 100%);
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: white;

  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

export const TitleBanner = styled.h2`
  font-size: 2.75rem;
  font-weight: bold;
  color: #ffffffff;
  line-height: 1.2;
  gap: 0.5rem;
`;

export const Description = styled.p`
  font-size: 1rem;
  line-height: 1.5;
  margin: 0 0 30px 0;
  opacity: 0.95;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

export const StatsContainer = styled.div`
  display: flex;
  gap: 40px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    gap: 20px;
    justify-content: space-between;
  }
`;

export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StatNumber = styled.span`
  font-size: 1.8rem;
  font-weight: bold;
  color: white;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const StatLabel = styled.span`
  font-size: 0.9rem;
  opacity: 0.9;
  margin-top: 4px;

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  span {
    font-size: 0.8rem;
    opacity: 0.9;
    text-transform: uppercase;
    font-weight: 600;
  }
`;

export const SubscribeButton = styled.button`
  background-color: white;
  color: #e91e63;
  border: none;
  border-radius: 25px;
  padding: 12px 24px;
  font-size: 0.9rem;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 50%;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 0.8rem;
  }
`;
